//TODO: evaluar si es necesaria esta directiva. Ver directiva clickAndWait.
angular.module('CarsSaraBo').directive('clickAndDisable', function () {
	return {
		scope: {
			clickAndDisable: '&'
		},
		link: function (scope, iElement, iAttrs) {
			iElement.bind('click', function () {
				scope.$parent.lockClickButton();
				scope.clickAndDisable();
				scope.$apply();
			});
		}
	};
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/click_and_disable.js
// module id = 874
// module chunks = 3